import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Radio, Tooltip, Tag,
    InputNumber
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { 
    deleteMacTemplateSecurity, addMacTemplateSecurity, getMacTemplateSecurity
} from "../../../axios/api.device"
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";
import { debug } from "console";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateConentSecurity = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const [securityPreferences, setSecurityPreferences] = useState<boolean>(false);
    const [systemPolicyControl, setSystemPolicyControl] = useState<boolean>(false);
    const [fDEFileVault, setFDEFileVault] = useState<boolean>(false);
    const [fDEFileVaultOptions, setFDEFileVaultOptions] = useState<boolean>(false);
    const [fileValutEnable, setFileValutEnable] = useState<string>("Off");
    const [useRecoveryKey, setUseRecoveryKey] = useState<boolean>(true);
    const [defer, setDefer] = useState<boolean>(true);
    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)

    }
    useEffect(() => {
        getDataInfo();
    }, [])

    const getDataInfo = () => {
        getMacTemplateSecurity(templateId).then((res) => {
            if (res && res != null) {
                setShowTable(2)
                var data: any = {};
                setSecurityPreferences(res.isSecurityPreferences);
                setSystemPolicyControl(res.isSystemPolicyControl);
                setFDEFileVault(res.isFDEFileVault);
                setFDEFileVaultOptions(res.isFDEFileVaultOptions);
                data.isSecurityPreferences = res.isSecurityPreferences;
                data.isSystemPolicyControl = res.isSystemPolicyControl;
                data.isFDEFileVault = res.isFDEFileVault;
                data.isFDEFileVaultOptions = res.isFDEFileVaultOptions;
                if(res.isSecurityPreferences)
                {
                    data.dontAllowFireWallUI = res.securityPreferences?.dontAllowFireWallUI;
                    data.dontAllowLockMessageUI = res.securityPreferences?.dontAllowLockMessageUI;
                    data.dontAllowPasswordResetUI = res.securityPreferences?.dontAllowPasswordResetUI;
                }
                if(res.isSystemPolicyControl)
                {
                    data.sourceType = res.systemPolicyControl?.sourceType;
                }
                if(res.isFDEFileVaultOptions)
                {
                    data.destroyFVKeyOnStandby = res.fdeFileVaultOptions?.destroyFVKeyOnStandby;
                    data.dontAllowFDEDisable = res.fdeFileVaultOptions?.dontAllowFDEDisable;
                    data.dontAllowFDEEnable = res.fdeFileVaultOptions?.dontAllowFDEEnable;
                }
                if(res.isFDEFileVault)
                {
                    data.enableType = res.fdeFileVault?.enableType;
                    data.forceEnableInSetupAssistant = res.fdeFileVault?.forceEnableInSetupAssistant;
                    // setFileValutEnable(res.fdeFileVault?.enable);
                    // data.enable = res.fdeFileVault?.enable;
                    // if(res.fdeFileVault?.enable != "Off")
                    // {
                    //     setUseRecoveryKey(res.fdeFileVault?.useRecoveryKey);
                    //     data.useRecoveryKey = res.fdeFileVault?.useRecoveryKey;
                    //     if(res.fdeFileVault?.enable != "Org")
                    //     {
                    //         if(data.useRecoveryKey)
                    //         {
                    //             data.outputPath = res.fdeFileVault?.outputPath;
                    //             data.showRecoveryKey = res.fdeFileVault?.showRecoveryKey;
                    //         }
                    //     }
                        
                    //     setDefer(res.fdeFileVault?.defer);
                    //     data.defer = res.fdeFileVault?.defer;
                    //     if(res.fdeFileVault?.defer)
                    //     {
                    //         data.deferForceAtUserLoginMaxBypassAttempts = res.fdeFileVault?.deferForceAtUserLoginMaxBypassAttempts;
                    //         data.deferDontAskAtUserLogout = res.fdeFileVault?.deferDontAskAtUserLogout;
                    //     }
                    //     else
                    //     {
                    //         data.userName = res.fdeFileVault?.userName;
                    //         data.password = res.fdeFileVault?.password;
                    //     }
                        
                    //     data.forceEnableInSetupAssistant = res.fdeFileVault?.forceEnableInSetupAssistant;
                    // }
                }
                console.log('data',data);
                dataForm?.setFieldsValue(data);
            } else {
                setShowTable(1)
            }
        })
    }
    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                var req: any = {};
                req.isSecurityPreferences = res.isSecurityPreferences;
                req.isSystemPolicyControl = res.isSystemPolicyControl;
                req.isFDEFileVault = res.isFDEFileVault;
                req.isFDEFileVaultOptions = res.isFDEFileVaultOptions;
                if(req.isSecurityPreferences)
                {
                    req.securityPreferences = {
                        dontAllowFireWallUI : res.dontAllowFireWallUI,
                        dontAllowLockMessageUI : res.dontAllowLockMessageUI,
                        dontAllowPasswordResetUI : res.dontAllowPasswordResetUI
                    };
                }
                if(req.isSystemPolicyControl)
                {
                    req.systemPolicyControl = {
                        sourceType : res.sourceType
                    }
                }
                if(req.isFDEFileVault)
                {
                    req.fDEFileVault = {
                        // enable : res.enable,
                        // useRecoveryKey : res.useRecoveryKey,
                        // outputPath : res.outputPath,
                        // showRecoveryKey : res.showRecoveryKey,
                        // defer : res.defer,
                        // deferForceAtUserLoginMaxBypassAttempts : res.deferForceAtUserLoginMaxBypassAttempts,
                        // deferDontAskAtUserLogout : res.deferDontAskAtUserLogout,
                        // userName : res.userName,
                        // password : res.password,
                        enableType : res.enableType,
                        forceEnableInSetupAssistant: res.forceEnableInSetupAssistant
                    }
                }
                if(req.isFDEFileVaultOptions)
                {
                    req.fDEFileVaultOptions = {
                        destroyFVKeyOnStandby : res.destroyFVKeyOnStandby,
                        dontAllowFDEDisable : res.dontAllowFDEDisable,
                        dontAllowFDEEnable : res.dontAllowFDEEnable
                    }
                }
                console.log(req);
                
                addMacTemplateSecurity(templateId, req).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    dataForm.resetFields();
                    getDataInfo();
                })
            })
    }
    const deleteTemplateClick = () => {
        deleteMacTemplateSecurity(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm?.resetFields();
            getDataInfo();
        })
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("安全")}</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities?.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        {/* <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("安全")}</p> */}
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <Form
                            style={{ width: "90%", marginTop: 36 }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 10 }}
                            initialValues={{isSecurityPreferences: false,isSystemPolicyControl:false,isFDEFileVault:false,isFDEFileVaultOptions:false,
                                dontAllowFireWallUI:false,dontAllowPasswordResetUI:false,dontAllowLockMessageUI:false,
                                sourceType:"Any",enable:"Off", enableType:"Login", defer: true,deferForceAtUserLoginMaxBypassAttempts:-1,
                                deferDontAskAtUserLogout: true,forceEnableInSetupAssistant:false,useRecoveryKey:true,
                                showRecoveryKey: false,dontAllowFDEEnable: false,dontAllowFDEDisable: false,destroyFVKeyOnStandby:false
                              }}
                        >
                            <Item label={t("安全偏好")} name="isSecurityPreferences">
                                <Select style={{width:"50%"}} onChange={(key: boolean) => {
                                    setSecurityPreferences(key);
                                }}>
                                    <Select.Option value={false}>{t("暂不设置")}</Select.Option>
                                    <Select.Option value={true}>{t("设置")}</Select.Option>
                                </Select>
                            </Item>
                            {securityPreferences && <>
                                <Item 
                                    label={t("防火墙")} 
                                    name="dontAllowFireWallUI"
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={false}>{t("允许修改")}</Select.Option>
                                        <Select.Option value={true}>{t("不允许修改")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("密码")} 
                                    name="dontAllowPasswordResetUI"
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={false}>{t("允许修改")}</Select.Option>
                                        <Select.Option value={true}>{t("不允许修改")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("锁屏文案")} 
                                    name="dontAllowLockMessageUI"
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={false}>{t("允许修改")}</Select.Option>
                                        <Select.Option value={true}>{t("不允许修改")}</Select.Option>
                                    </Select>
                                </Item>
                            </>}

                            <Item label={t("GatePeeker")} name="isSystemPolicyControl">
                                <Select style={{width:"50%"}} onChange={(key: boolean) => {
                                    setSystemPolicyControl(key);
                                }}>
                                    <Select.Option value={false}>{t("暂不设置")}</Select.Option>
                                    <Select.Option value={true}>{t("设置")}</Select.Option>
                                </Select>
                            </Item>
                            {systemPolicyControl && <>
                                <Item 
                                    label={t("允许应用下载来源")} 
                                    name="sourceType"
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={"Any"}>{t("任意来源")}</Select.Option>
                                        <Select.Option value={"AppStore"}>{t("App Store")}</Select.Option>
                                        <Select.Option value={"AppStoreAndDeveloper"}>{t("App Store和可信任开发者")}</Select.Option>
                                    </Select>
                                </Item>
                            </>}
                            <Item name="isFDEFileVault" label={t("FileValut")}>
                                <Select style={{width:"50%"}} onChange={(key: boolean) => {
                                    setFDEFileVault(key);
                                }}>
                                    <Select.Option value={false}>{t("暂不设置")}</Select.Option>
                                    <Select.Option value={true}>{t("设置")}</Select.Option>
                                </Select>
                            </Item>
                            {fDEFileVault && <>
                                <Item 
                                    label={t("提示开启FileValut场景：")} 
                                    name="enableType"
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Select style={{width:"50%"}} >
                                        <Select.Option value={"Login"}>{t("登录")}</Select.Option>
                                        <Select.Option value={"Logout"}>{t("登出")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("在激活设备时开启FileValut")} 
                                    name="forceEnableInSetupAssistant"
                                    style={{paddingLeft:"60px"}}
                                    extra={"此配置需要在预注册时下发"}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={false}>{t("不启用")}</Select.Option>
                                        <Select.Option value={true}>{t("启用")}</Select.Option>
                                    </Select>
                                </Item>
                                {/* <Item 
                                    label={t("FileValut操作")} 
                                    name="enable"
                                    style={{paddingLeft:"60px"}}
                                    extra={"直接删除配置文件不会关闭，需要选择关闭操作"}
                                >
                                    <Select style={{width:"50%"}} onChange={(key: string) => {
                                        setFileValutEnable(key);
                                    }}>
                                        <Select.Option value={"Person"}>{t("启用")}</Select.Option>
                                        <Select.Option value={"Off"}>{t("关闭")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("托管个人Recovery Key")} 
                                    name="useRecoveryKey"
                                    hidden={fileValutEnable == "Off"}
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Select style={{width:"50%"}} onChange={(key: boolean) => {
                                        setUseRecoveryKey(key);
                                    }}>
                                        <Select.Option value={true}>{t("启用")}</Select.Option>
                                        <Select.Option value={false}>{t("不启用")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("展示Recovery Key")} 
                                    name="showRecoveryKey"
                                    hidden={fileValutEnable == "Off" || useRecoveryKey == false}
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={true}>{t("启用")}</Select.Option>
                                        <Select.Option value={false}>{t("不启用")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("托管位置描述")} 
                                    name="outputPath"
                                    hidden={fileValutEnable == "Off" || useRecoveryKey == false}
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Input  style={{width:"50%"}}></Input>
                                </Item>
                                <Item 
                                    label={t("认证")} 
                                    name="defer"
                                    hidden={fileValutEnable == "Off"}
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Select style={{width:"50%"}} onChange={(key: boolean) => {
                                        setDefer(key);
                                    }}>
                                        <Select.Option value={true}>{t("延迟启用直到登出")}</Select.Option>
                                        <Select.Option value={false}>{t("手动")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("Filevalut可跳过次数")} 
                                    name="deferForceAtUserLoginMaxBypassAttempts"
                                    hidden={ fileValutEnable == "Off" || defer == false}
                                    style={{paddingLeft:"60px"}}
                                >
                                    <InputNumber style={{width:"50%"}} min={-1} max={5}/>
                                </Item>
                                <Item 
                                    label={t("在登陆时询问")} 
                                    name="deferDontAskAtUserLogout"
                                    hidden={fileValutEnable == "Off" || defer == false}
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={true}>{t("不启用")}</Select.Option>
                                        <Select.Option value={false}>{t("启用")}</Select.Option>
                                    </Select>
                                </Item> */}
                                {/* <Item 
                                    label={t("用户名")} 
                                    name="userName"
                                    hidden={fileValutEnable == "Off" || defer == true}
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Input style={{width:"50%"}}/>
                                </Item>
                                <Item 
                                    label={t("密码")} 
                                    name="password"
                                    hidden={fileValutEnable == "Off" || defer == true}
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Input.Password style={{width:"50%"}} />
                                </Item> */}
                            </>}

                            <Item label={t("FDEFileVaultOptions")} name="isFDEFileVaultOptions">
                                <Select style={{width:"50%"}} onChange={(key: boolean) => {
                                    setFDEFileVaultOptions(key);
                                }}>
                                    <Select.Option value={false}>{t("暂不设置")}</Select.Option>
                                    <Select.Option value={true}>{t("设置")}</Select.Option>
                                </Select>
                            </Item>

                            {fDEFileVaultOptions && <>
                                <Item 
                                    label={t("阻止启用FileValut")} 
                                    name="dontAllowFDEEnable"
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={false}>{t("允许")}</Select.Option>
                                        <Select.Option value={true}>{t("禁止")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("阻止禁用FileValut")} 
                                    name="dontAllowFDEDisable"
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={false}>{t("允许")}</Select.Option>
                                        <Select.Option value={true}>{t("禁止")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item 
                                    label={t("待机模式下销毁FileValut密钥")} 
                                    name="destroyFVKeyOnStandby"
                                    style={{paddingLeft:"60px"}}
                                >
                                    <Select style={{width:"50%"}}>
                                        <Select.Option value={false}>{t("允许")}</Select.Option>
                                        <Select.Option value={true}>{t("禁止")}</Select.Option>
                                    </Select>
                                </Item>
                            </>}
                        </Form>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "60%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};